const tabs = [
    { name: 'Aprobar', href: '', current: false },
    { name: 'Perfil', href: '', current: false },
    { name: 'Especialidades', href: '', current: false },
    { name: 'Idioma', href: '', current: false },
    { name: 'Experiencia', href: '', current: false },
    { name: 'Educación', href: '', current: false },
    { name: 'Motivos', href: '', current: false },
    { name: 'Servicios', href: '', current: false },
    { name: 'Horarios', href: '', current: false },
    { name: 'Citas', href: '', current: false },
    { name: 'Info', href: '', current: false }
];

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export default function DoctorProfileTabs(props) {
    const { selectedItem, updateNavigation } = props;

    tabs.forEach((element, index) => {
        tabs[index].current = element.name === selectedItem;
    });

    const _onLinkClick = (event, tabName) => {
        event.preventDefault();
        updateNavigation(tabName);
    };

    const _onLinkClickSelect = (event) => {
        event.preventDefault();
        updateNavigation(event.target.value);
    };

    return (
        <div>
            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>
                {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                <select
                    id="tabs"
                    name="tabs"
                    onChange={(event) => _onLinkClickSelect(event)}
                    className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                    defaultValue={tabs.find((tab) => tab.current).name}
                >
                    {tabs.map((tab) => (
                        <option key={tab.name}>{tab.name}</option>
                    ))}
                </select>
            </div>
            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex space-x-8 ml-5" aria-label="Tabs">
                        {tabs.map((tab) => (
                            <button
                                key={tab.name}
                                // href={tab.href}
                                onClick={(e) => _onLinkClick(e, tab.name)}
                                className={classNames(
                                    tab.current
                                        ? 'border-dl-primary-500 text-dl-primary-700'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                    'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
                                )}
                                aria-current={tab.current ? 'page' : undefined}
                            >
                                {tab.name}
                            </button>
                        ))}
                    </nav>
                </div>
            </div>
        </div>
    );
}
